// frontend/src/auth/AdminRoute.js
import React from 'react';
import { useAuth } from './AuthContext';
import { Navigate } from 'react-router-dom';

const AdminRoute = ({ children }) => {
    const { esRol } = useAuth();

    // Si el usuario no es ADMIN ni PROGRAMADOR, redirige a la página de inicio.
    if (!esRol('ADMIN', 'PROGRAMADOR')) {
        return <Navigate to="/home" replace />;
    }

    // Si es ADMIN o PROGRAMADOR, permite el acceso.
    return children;
};

export default AdminRoute;
